import React from "react";
import { HOUR_HEIGHT, TIME_COLUMN_WIDTH, TIMELINE_HEIGHT, GRID_LINE_COLOR } from "./CalendarConstants";

const TimelineGrid = () => {
  const hours = Array.from({ length: 24 }, (_, i) => i);

  return (
    <div style={{ position: "relative", width: "100%", height: TIMELINE_HEIGHT }}>
      {hours.map((hour) => (
        <div key={hour} style={{ position: "absolute", top: hour * HOUR_HEIGHT, width: "100%", height: HOUR_HEIGHT }}>
          {/* Time label */}
          <div style={{
            position: "absolute",
            top: -7,
            left: 0,
            width: TIME_COLUMN_WIDTH - 8,
            textAlign: "right",
            fontSize: 11,
            fontWeight: 500,
            color: "#9E9E9E",
            userSelect: "none",
          }}>
            {String(hour).padStart(2, "0")}:00
          </div>
          {/* Hour line */}
          <div style={{
            position: "absolute",
            top: 0,
            left: TIME_COLUMN_WIDTH,
            right: 0,
            height: 0.5,
            backgroundColor: GRID_LINE_COLOR,
          }} />
        </div>
      ))}
      {/* Bottom line at 24:00 */}
      <div style={{
        position: "absolute",
        top: 24 * HOUR_HEIGHT,
        left: TIME_COLUMN_WIDTH,
        right: 0,
        height: 0.5,
        backgroundColor: GRID_LINE_COLOR,
      }} />
    </div>
  );
};

export default React.memo(TimelineGrid);
